
import './Footer.css';
import { Link } from 'react-router-dom';
import { FaFacebook } from "react-icons/fa";
import TranslateChoosedFilters from '../TranslateChoosedFilters/TranslateChoosedFilters';

const CookiesPage = () => {
  return (
    <div id='FooterMainDiv'>
  
    <TranslateChoosedFilters />

       <Link to='/' className='MainLogoText'>
         SteelJobs.pl
       </Link>
         <a className='FooterLink' >steeljobs@steeljobs.pl</a>
            <a href="https://www.facebook.com/profile.php?id=100083031086146" target="_blank" rel="noopener noreferrer">
               <FaFacebook className='MainPageFBIcon'/>
            </a>

      <div className='FooterInfoLinks'>
        <Link to='/Polityka' className='FooterLink'>Polityka prywatności</Link>
        <Link to='/Cookies' className='FooterLink'>Polityka cookies</Link>
        <Link to='/Regulamin' className='FooterLink'>Regulamin</Link>
        <Link to='/Kontakt' className='FooterLink'>Kontakt</Link>
        <Link to='/Reklama' className='FooterLink'>Reklama</Link>
      </div>

    </div>
  )
};

export default CookiesPage;
